import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from '../../../../assets/AddIcon.svg';
import style from './styles.scss';

const EmptySetComp = ({ setShowSetComp }) => {
  return (
    <div className={style.emptySetBox}>
      <div className={style.emptySelectSet}>
        <button className={style.AddClickIcon}>
          <img src={AddIcon} onClick={() => setShowSetComp(true)} alt="ADD" />
        </button>

        <div>
          <div
            style={{
              color: '#BEC3CA',
              fontSize: '14px'
            }}>
            No Sets currently chosen
          </div>
          <div className="" style={{ fontSize: '14px', color: '#3F516F' }}>
            Click to select one
          </div>
        </div>
      </div>
    </div>
  );
};

EmptySetComp.propTypes = {
  setShowSetComp: PropTypes.func
};

export default EmptySetComp;
